<template>

    <div v-if="product && order">

        <div class="row margin-t-150">

            <article class="wrap--product">

                <div class="col-12 margin-tb-50">

                    <a href="/">Se alle produkter</a>

                </div>

                <section class="product">

                    <div class="img margin-b-25">

                        <img :srcset="sourceSet" :src="'/storage/images/' + product.image" :alt="product.title">

                    </div>

                    <div class="content">

                        <h1>{{product.title}}</h1>

                        <nl2br tag="p" :text="product.description"></nl2br>

                        <a href="https://wiki.naesbyhovedskov.dk/" target="_blank">Se tilberedning & levering her</a>

                        <h3>Pris pr. stk.</h3>

                        <h4>{{stripeAmount(product.price).amount}},-</h4>

                        <ul>
                            <li><i class="icon--md fas fa-info-circle"></i> Minimumsbestilling er {{product.min_quantity}} stk.</li>
                            <li v-if="product.category_exceptions !== null && product.category_exceptions.hasOwnProperty('newyears') && product.category_exceptions.newyears"><i class="icon--md fas fa-info-circle"></i> Kan bestilles indtil d. 28 dec. / indtil udsolgt</li>
                            <li v-else><i class="icon--md fas fa-info-circle"></i> Kan bestilles indtil dagen før kl. 12.00 / indtil udsolgt</li>
                            <li><i class="icon--md fas fa-info-circle"></i> Alle retter afhentes / afleveres kolde</li>
                        </ul>

                        <div class="col-12 margin-t-25">

                            <incrementer v-model="quantity" :min="product.min_quantity" increase="quantityIncrease" decrease="quantityDecrease"></incrementer>

                        </div>

                    </div>

                </section>

            </article>

        </div>

        <div class="row">

            <selection-item v-for="selection in product.selections" :selection="selection" :key="selection.id"></selection-item>

        </div>

        <div class="row">

            <div class="addons" v-for="selection in product.extra_selections">

                <article class="wrap--product">

                    <header class="addons__header border-b padding-b-25 margin-b-50">

                        <h1>Tilkøb - {{selection.title}} </h1>

                    </header>

                    <main class="addons__items">

                        <option-item v-for="option in selection.options" :option="option" :selection="selection" :as-extra="true" :key="option.id" :start-quantity="getExtraOptionStartQuantity(selection, option)"></option-item>

                    </main>

                </article>

            </div>

        </div>

        <total></total>

    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import PlusMinusNumberInput from './../../partials/PlusMinusNumberInput.vue';
    import Option from './partials/option.vue';
    import Selection from './partials/selection.vue';
    import Total from './partials/total.vue';
    import moment from 'moment';

    export default {
        name: "CustomProduct",
        components:{
            'incrementer':PlusMinusNumberInput,
            'option-item':Option,
            'selection-item':Selection,
            Total
        },
        computed:{
            ...mapGetters({
                product:'product',
                order:'order',
            }),
            quantity:{
                get(){
                    return this.order.details.quantity;
                },
                set(value){
                    this.$store.dispatch('setQuantity', value);
                }
            },
            sourceSet(){
                return '/storage/images/' + this.product.image_x1 + ' 1x, ' + '/storage/images/' + this.product.image + ' 2x';
            },
            orderDate(){
                return moment().endOf('year').subtract(1, 'days');
            }
        },
        watch:{
            product(value){
                this.setupFlow(value);
            },
        },
        methods:{
            setupFlow(value){
                this.$store.dispatch('setOrderProduct', value);
                this.$store.dispatch('setQuantity', value.min_quantity);
                this.$store.dispatch('setCustomSelections', value.selections);
                this.$store.dispatch('setCustomExtraSelections', value.extra_selections);
            },
            getExtraOptionStartQuantity(selection, option){
                const extraSelection = this.order.details.extra_selections.find(item => {
                    return item.extra_selection_id === selection.id;
                });

                const optionData = extraSelection.options.find(item => item.id === option.id);

                if(!optionData){
                    return 0;
                }

                return optionData.quantity;
            }
        }
    }
</script>

<style scoped>

</style>
